const carrierSearchRouter = {
    path: "carrier-search",
    name: "carrier-search",
    meta: {
        title: "载体搜索"
    },
    redirect: {
        name: "carrier-search-list"
    },
    component: () => import("@/pages/index/home/projectSearch/CarrierSearch.vue"),
    children: [
        {
            path: "carrier-search-list",
            name: "carrier-search-list",
            meta: {
                title: "载体搜索-列表页"
            },
            component: () => import("@/pages/carrierCommon/List")
        }
    ]
};
export default carrierSearchRouter;


// WEBPACK FOOTER //
// ./src/router/index/home/carrierSearch.js